import { lazy } from 'react';
// project import
import Loadable from '../../components/Loadable';
// import { RequireAuthorizedAccess } from "routes/guards/RequireAuthorizedAccess";
// import Permissions from "const/Permissions";
// ==============================|| ROUTES ITEMS - DETECTOR ||============================== //

// render - DETECTOR
const DetectorPage = Loadable(
    lazy(() => import('../../pages/detector/DetectorPage')),
);

const detector = {
    path: 'detector',
    element: (
        // <RequireAuthorizedAccess permissions={Permissions.DashboardSection.Dashboard}>
        <DetectorPage />
        // </RequireAuthorizedAccess>
    ),
};

export default detector;
